import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign.ts';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { getWelcomeScreenConfig } from '../../utils/getWelcomeScreenConfig';

import {
  ContentContainerStyles,
  PageStyles,
  WelcomeBannerStyles,
  WelcomeDescriptionStyles,
} from './Welcome.styles';

export const ScreenWelcome: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Domination welcome screen',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const notes = webCampaign.getLayoutNotes();
  const config = getWelcomeScreenConfig(notes);

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination" backgroundImage={config.background}>
      <IonContent>
        <ContentContainerStyles>
          <LogoWithAppName className="app-logo" withCaption={false} />
          <WelcomeBannerStyles src={config.welcomeBanner} />
          <WelcomeDescriptionStyles>
            {config.welcomeDescription}
          </WelcomeDescriptionStyles>
        </ContentContainerStyles>

        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonText={config.footerText}
          buttonRadius={'sm'}
          buttonSize={'medium'}
        />
      </IonContent>
    </PageStyles>
  );
};
